import React, { useEffect, useState} from "react";
import offlineDataIcon from "../../../assets/offline-data-enrichment.svg"
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Tooltip from 'react-bootstrap/Tooltip';
import { useSelector } from "react-redux";
import { getLicenseDate, isDownloadTimeValid } from "../../../utils/utils";

// Utility functions
const formatDate = (isoDateString) => {
  const date = new Date(isoDateString);

  const weekday = date.toLocaleString("en-US", { weekday: "short" }); // Sun
  const day = date.toLocaleString("en-US", { day: "2-digit" });       // 22
  const month = date.toLocaleString("en-US", { month: "short" });     // Jun
  const year = date.getFullYear();                                    // 2025

  return `${weekday}, ${day} ${month} ${year}`;
};


const formatSize = (bytes) => {
  const sizeInMB = bytes / (1024 * 1024);
  return Math.round(sizeInMB * 10) / 10 + " MB";
};


const DatabaseDownloadButton = ({ onDownload, isDisabled, isDownloading, dbLibraryCheckSumVar, DBFileLastModified, DBFileSize }) => {
  const progress = useSelector((state) => state?.users?.dbDirectProgress);

  const userId = useSelector((state) => state?.users?.user?.username);
  const aboutYou = useSelector((state) => state?.stage?.aboutYou);

  const [datsInfoshow, datsInfosetShow] = useState(false);
  const [lastModified, setLastModified] = useState("");
  const [fileSize, setFileSize] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const datsInfoClose = () => datsInfosetShow(false);
  const datsInfoShow = () => datsInfosetShow(true);

  // Monitor aboutYou changes and update button state
  useEffect(() => {
    // console.log("AboutYou state changed:", {
    //   DownloadDatabaseTime: aboutYou?.DownloadDatabaseTime,
    //   LicenseExpDate: aboutYou?.LicenseExpDate,
    //   Plan: aboutYou?.Plan,
    //   DownloadTime: aboutYou?.DownloadTime
    // });
    setButtonDisabled(isDatabaseDownloadDisabled());
  }, [aboutYou?.DownloadDatabaseTime, aboutYou?.LicenseExpDate, aboutYou?.DownloadTime, progress, userId]);

  const isDatabaseDownloadDisabled = () => {
    const planName = aboutYou?.Plan;
    const progressValue = progress;

    const utcTimestamp = Math.floor(Date.now() / 1000);
    const gmtOffsetSeconds = 5.5 * 60 * 60; // 5 hours 30 mins
    const gmt530Timestamp = utcTimestamp + gmtOffsetSeconds;

    const isLicenseExpired = aboutYou?.LicenseExpDate && Number(aboutYou.LicenseExpDate) <= gmt530Timestamp;
    

    // console.log("aboutYou", aboutYou?.LicenseExpDate);
    // console.log("Number", Number(aboutYou.LicenseExpDate));
    // console.log("Cuurent Date", gmt530Timestamp);



    // console.log("🔍 DatabaseFile - Checking eligibility:", {
    //   userId,
    //   planName,
    //   progress: progressValue,
    //   hasDownloadTime: !!aboutYou?.DownloadDatabaseTime,
    //   LicenseExpDate: aboutYou?.LicenseExpDate,
    //   DownloadTime: aboutYou?.DownloadTime,
    //   isLicenseExpired
    // });

    if (!userId || !planName) {
      return true; // Required info missing
    } else if (progressValue > 0 && progressValue < 100) {
      return true; // Download in progress
    }

    console.log("isLicenseExpired", isLicenseExpired);
    // console.log("isDownloadTimeValid", aboutYou?.DownloadTime, isDownloadTimeValid(aboutYou?.DownloadTime));


    // Check if download time is valid (cooldown passed)
    // if (isDownloadTimeValid(aboutYou?.DownloadTime)) {
    //   // Simple logic: disable if license expired, allow if license valid
    //   if (isLicenseExpired) {
    //     return true; // License expired, disable
    //   } else {
    //     return false; // License valid, allow download
    //   }
    // } else {
    //   return true; // Blocked due to cooldown
    // }

    // Check if download time is valid (cooldown passed)
    if (isDownloadTimeValid(aboutYou?.DownloadTime)) {
        // Simple logic: disable if license expired, allow if license valid
        return isLicenseExpired;
    }    
    
    // Blocked due to cooldown
    return true;
  };

  useEffect(() => {
    const fetchMetadata = async () => {
      if (DBFileLastModified && DBFileSize) {
        setLastModified(formatDate(DBFileLastModified));
        setFileSize(formatSize(DBFileSize));
      }
    };

    fetchMetadata();
  }, [DBFileLastModified, DBFileSize]);



return (
    <>
        <div className="addon-col">
            <div className="addon-col-icon"><img src={offlineDataIcon} alt="" /></div>
            <h3>Offline Data Enrichment <button className="addon-learn-btn" onClick={datsInfoShow}><span className="material-icons-outlined tooltip-box tooltip--top" data-content="Info">info_i</span></button></h3>
            <p>
              Enrich your network data without internet access.<br/>
              <div className="enrichment-info">
                <p><span className="tooltip-box tooltip--top" data-content="Size">{fileSize}</span> | <span className="tooltip-box tooltip--top" data-content="Latest Update">{lastModified}</span> | <span>Supports CARBN.AI V4.5.6 or higher</span></p>
              </div>
            </p>

            
              
            <div className="addon-btn-row">
              

                  <button
                    className="download-license-text download-license-margin tooltip-box tooltip--top"
                    onClick={onDownload}
                    disabled={buttonDisabled} data-content="Supports CARBN.AI V4.5.6 or higher">
                        Download
                  </button>
              
                  {(progress > 0 && progress <= 100) && (
                    <div
                      className="db-netify-progress-bar"
                      role="progressNetifybar"
                      aria-valuenow={`${progress}`}
                      aria-valuemin="0"
                      aria-valuemax="100"
                      style={{ '--value': `${progress}` }}
                    >
                      <span className="progressbar-percentage" style={{ width: `${progress}%` }}>
                        <div className="progress-count">{(progress > 0 && progress <= 100) && progress.toFixed(2) + "%"}</div>
                      </span>
                    </div>
                  )}
  
              
              
            </div>
            <p className="note-box">Note: This updates every week.</p>

        </div>

        <input type="hidden" value={dbLibraryCheckSumVar} className="netify-data-harvestor"></input>    

        {/* Offline Data More Info Start */}
        <Modal className="datsInfo-modal" show={datsInfoshow} onHide={datsInfoClose}>
            <Button className="datsInfo-close" onClick={datsInfoClose}>X</Button>
            <Modal.Body>
              <h3>Offline Data Enrichment</h3>
              <p>Automatically identifies application names from server IP addresses using a local database. This enriches your network data by matching IP addresses to popular applications and services without requiring external API calls.</p>
              <h4>Benefits:</h4>
              <ul>
                <li>Enhanced visibility into application usage</li>
                <li>Privacy-focused offline processing</li>
                <li>Regular database updates for accuracy</li>
              </ul>
              <p>Offline Data Enrichment requires CARBN version 4.5.6 or higher.</p>
            </Modal.Body>
        </Modal>
        {/* Offline Data More Info End */}

    </>
  );
};

export default DatabaseDownloadButton;
